$.getUrlParameters = function (parameter) {
	var results = new RegExp('[\?&]' + parameter + '=([^&#]*)').exec(window.location.href);
	if (results == null) {
		return null;
	}
	else {
		return results[1] || 0;
	}
}

function scrollToSection(sid) {
	var div = $(sid);
	var elemTop = div.offset().top - 50;
	//console.log('top:'+elemTop);
	$('html, body').animate({ scrollTop: elemTop }, 'slow');
	return false;
}

function scrollToNextSection() {
	var el = $('.maincontent section:nth-child(2)');
	var elemTop = el.offset().top / 2 + 120;

	$('html, body').animate({ scrollTop: elemTop }, 'slow');
	return false;
}

function isTouchOn() {
	return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}

// When the user clicks on the button, scroll to the top of the document
function gotoTop() {
	$('html, body').stop(true, false).animate({
		scrollTop: 0
	}, 1000);
}

function toTitleCase(str) {
	return str.replace(/(?:^|\s)\w/g, function (match) {
		return match.toUpperCase();
	});
}

function scrollToAnchor(sid) {
	var div = $(sid);
	$('html, body').animate({ scrollTop: div.offset().top - 200 }, 'slow');
	return false;
}

$(function () {
	/* Store the window width */
	var windowWidth = $(window).width();
	var qStr = '';
	// This is used for testing while in development
	// Need to comment out for release
	/*
	$(window).resize(function (e) {
		// Check if the window width has actually changed and it's not just iOS triggering a resize event on scroll
		if ($(window).width() != windowWidth) {
			// Update the window width for next time
			windowWidth = $(window).width();
			setTimeout(function () {
				this.location.reload(false);
			}, 50);
		}
	});
	*/
	//-----------------------------------------------

	/* Search - enter to seearch */
	$('#headerSearchForm').on('submit', function (e) {
		console.log('here');
		e.preventDefault();
	});

	$(document).on('keypress', '#search-box, #resource-search-box', function (e) {
		if (e.which == 13) {
			$('#btnSearch, #resource-btnSearch').trigger('click');
		}
	});

	/* back-to-top */
	$(window).on('scroll', function () {
		var scrollTop = $(this).scrollTop();
		if (scrollTop > 20) {
			$('footer .back-to-top').addClass('show').on('click', function () {
				gotoTop();
			});

			if ($('#resources-filters').length > 0) {
				$('.search-icon').addClass('move-down');
			}

			if ($('#scroll-down-btn').length > 0) {
				$('#scroll-down-btn').addClass('hide');
			}
		}
		else {
			$('footer .back-to-top').removeClass('show');
			if ($('#resources-filters').length > 0) {
				$('.search-icon').removeClass('move-down');
			}

			if ($('#scroll-down-btn').length > 0) {
				$('#scroll-down-btn').removeClass('hide');
			}
		}
	});

	$('#scroll-down-btn').on('click', function () {
		//console.log('btn clicked');
		scrollToSection('#resources-info');
		$(this).addClass('hide');
	});

	/* resources - set default audience */
	if ($('.section--resources-results').length > 0) {
		/*$('.filters-list > a').first().addClass('highlight');*/
		var defAudience = $('.section--resources-results').hasClass('educators') ? 'Educators' : 'Parents';
		console.log('def:' + defAudience);
		$('#audience-list .checkbox input[value="' + defAudience +'"]').prop('checked', true);
	}

	/* side-menu - anchor link to section */
	if ($('#side-menu').length > 0) {		
		$('#side-menu button').each(function () {
			$(this).on('click', function () {
				$('#side-menu li').removeClass('active');
				var section = '#' + $(this).attr('data-goto');
				$(this).parent().addClass('active');
				scrollToSection(section);
			});
		});
	}

	/* handling querystring */
	if ($.getUrlParameters('courseType') != null) {
		qStr = $.getUrlParameters('courseType').toLowerCase();
		$('.page-header-intro .levels a').removeClass('active').filter(function (index) {
			return $(this).text().toLowerCase() === qStr;
		}).addClass('active');
	}

	/* handling steps content (students) */
	if ($(location).attr('hash') != '') {
		var hash = $(location).attr('hash');
		//console.log('hash: ' + hash);
		$('#school-levels').addClass('hide');
		if (hash == '#step2-primary') {
			$('#school-level-pri').removeClass('hide');
		}
		else if (hash == '#step2-secondary') {
			$('#school-level-sec').removeClass('hide');
		};
	}

	$('#school-levels .level-btns .primary-btn').on('click', function () {
		$('#school-levels').addClass('hide');
		if ($(this).attr('href') == '#step2-primary') {
			$('#school-level-pri').removeClass('hide');
		}
		else if ($(this).attr('href') == '#step2-secondary') {
			$('#school-level-sec').removeClass('hide');
		};
	});

	/* close subscribe, global search when clicked outside */
	$(document).on('mouseup', function (e) {
		var container = null;
		if ($('#search-form').hasClass('show')) {
			container = $('#search-form');
		} else if ($('#subscribe-form').hasClass('show')) {
			container = $('#subscribe-form');
		} else if ($('#header-menu').hasClass('show')) {
			container = $('#header-menu');
		}

		if (!container) return;

		// if the target of the click isn't the container nor a descendant of the container
		if (!container.is(e.target) && container.has(e.target).length === 0) {
			container.removeClass('show');
			container.prev('a').attr('aria-expanded', 'false');
		}
	});

	/*handling annchor links in parent accordion*/
	if ($.getUrlParameters('anchor') != null) {
		let anchorName = '#' + $.getUrlParameters('anchor');
		//console.log('anchor:' + anchorName);
		var $el = $(anchorName);
		// -- parent accordion --
		let $elParent = $el.parent().parent().parent().parent();
		// check anchor content 
		if ($elParent.attr('class') == 'accordion-item collapse') {
			let parentId = $elParent.attr('id');
			let aLinkId = parentId.replace('_content', '');
			$('#' + aLinkId).attr('aria-expanded', 'true');
			$elParent.addClass('show');
			scrollToAnchor(anchorName);
		}
	}

});